/* global angular */

var ngModule = angular.module('trends');

ngModule.directive('filters', ['AjaxList', 'Api', 'HistoricContext', '$parse',
    function (AjaxList, Api, HistoricContext, $parse) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                scope.filters = {};
                scope.filters.sources = {};

                var preserveType = attrs.preserveType;
                var params = $parse(attrs.filterParams || '{}')(scope);

                var filterVal = null;
                if (attrs.filtersIgnoreContext === undefined) {
                    if (preserveType === 'homepage') {
                        filterVal= HistoricContext.getValue('home_filters');
                    }
                    else {
                        filterVal= HistoricContext.getValue('temporary_filter_context');
                    }

                    if (filterVal) {
                        scope.filters.selected = filterVal;
                        HistoricContext.insert('temporary_filter_context', filterVal, 'session');
                    } else {
                        scope.filters.selected = {};
                    }
                }

                scope.filters.params = {};
                if (params.fixed_value && params.fixed_group) {
                    scope.filters.selected[params.fixed_group] = params.fixed_value;
                    scope.filters.params[params.fixed_group + '_fixed'] = true;
                }

                if (scope.filters.selected) {
                    scope.filters.active = angular.copy(scope.filters.selected);
                }

                angular.forEach(Api.filters, function (v, k) {
                    scope.filters.sources[k] = new AjaxList(Api.filters[k],{
                        defaultParams: {order_by: 'description'},
                        cached: true
                    });

                    scope.filters.sources[k].loadNext();
                });

                if (attrs.filtersIgnoreContext === undefined) {
                    scope.$watch('filters["selected"]', function(newValue, oldValue) {
                        if (newValue !== oldValue) {
                            if (preserveType === 'homepage') {
                                HistoricContext.insert('home_filters', newValue, 'db');
                            }

                            HistoricContext.insert('temporary_filter_context', newValue, 'session');
                            HistoricContext.save();
                        }
                    }, true);
                }
            }
        };
    }]);
